// extracted by mini-css-extract-plugin
export default {"buttonContainer":"newsletter_buttonContainer__Eg7d1","textContainer":"newsletter_textContainer__qyHjm","text":"newsletter_text__exApJ"};